import React from 'react';

import { tooltipsTypes } from './actions'


const initialState = {
    isFetching: false,
    data: []
}


export function tooltips(state = initialState, action) {

    switch(action.type) {

        case tooltipsTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            return state

        case tooltipsTypes.RECEIVE:
            state = {...state, isFetching: false}
            state.data = action.data

            return state


        default:
            return state
    }
}